/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Box, Text } from '@tishman/components';
import * as Icons from '@tishman/icons';
import { useSpring, animated } from '@react-spring/web';
import React from 'react';

interface LoaderProps {
  opacity?: number;
  message?: string;
}

export const ModalLoader = ({
  opacity = 0.8,
  message,
}: LoaderProps): React.JSX.Element => {
  const wipe = useSpring({
    loop: true,
    from: {
      height: '0px',
    },
    to: {
      height: '157px',
    },
    config: { duration: 600 },
    delay: 1000,
  });
  return (
    <Box
      data-testid="modal-loader"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        background: `rgba(255, 255, 255, ${opacity})`,
        zIndex: 'overlay',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <animated.div
        style={{
          ...wipe,
          left: '50%',
          marginBottom: '50px',
          marginTop: '50px',
          overflow: 'hidden',
          position: 'fixed',
          top: '50%',
          transform: 'translate(-50%, -157px)',
          width: '307px',
        }}
      >
        <Icons.RockefellercenterLogo style={{ color: 'black' }} />
      </animated.div>
      {message && (
        <Text
          sx={{
            color: 'black',
            textAlign: 'center',
            marginTop: '150px',
            whiteSpace: 'pre-wrap',
          }}
          variant="mediumP"
        >
          {message}
        </Text>
      )}
    </Box>
  );
};
